/**
 * Classroom trainees API – all endpoints used by classroom trainees management.
 * Base path: /admin/classroom (classroom trainees routes mounted in backend organization routes).
 *
 * All endpoints return the standard shape:
 * - Success: { success: true, statusCode, message, data }
 * - Error: thrown with message from backend (response: { success: false, statusCode, message, error: { message } })
 * Use response.data for payload (e.g. response.data.trainees, response.data.users, response.data.pagination).
 */
import {
  DELETE,
  GET,
  POST,
} from "../../apiController";

const CLASSROOM_TRAINEES = '/admin/classroom';

// ==================== CLASSROOM TRAINEES ====================

// Get trainees details for a classroom
export const getTrainees = (data) => {
  return POST(`${CLASSROOM_TRAINEES}/trainee`, data);
};

/** GET — roster report for trainees in this classroom (name, email, phone) */
export const getClassroomTraineesAnalyticsReport = (classId) => {
  return GET(`${CLASSROOM_TRAINEES}/trainee/analytics_report/${encodeURIComponent(classId)}`);
};

// Remove trainee from classroom
export const removeTraineeFromClassroom = ({ user_id, class_id }) => {
  return DELETE(
    `${CLASSROOM_TRAINEES}/trainee?user_id=${user_id}&class_id=${class_id}`
  );
};

// Get all users from organization (except those in classroom)
export const getAllUsersExceptClassroom = (data) => {
  return POST(`${CLASSROOM_TRAINEES}/get_all_trainees`, data);
};

// Add multiple trainees to classroom
export const addTraineesToClassroom = (data) => {
  return POST(`${CLASSROOM_TRAINEES}/trainee/add`, data);
};

// Delete multiple trainees from classroom
export const deleteMultipleTrainees = (data) => {
  return POST(`${CLASSROOM_TRAINEES}/trainee/delete`, data);
};
